export enum WeblogPageCategory {
  EUROPE_TRAIN_TICKET_MAIN = '유럽 열차 검색 홈',
  EUROPE_TRAIN_TICKET_SEARCH_BRIDGE = '유럽 열차 구간권 검색 브릿지',
  EUROPE_TRAIN_TICKET_SEARCH_RESULT = '유럽 열차 구간권 검색 결과',
  EUROPE_TRAIN_TICKET_OPTION = '유럽 열차 구간권 옵션 선택',
  EUROPE_TRAIN_TICKET_DETAILS = '유럽 열차 구간권 티켓 상세',
  EUROPE_TRAIN_TICKET_PASSENGER_DETAILS = '유럽 열차 구간권 승객 정보 입력',
}

export enum WeblogScreenName {
  EUROPE_TRAIN_TICKET_MAIN = 'europe_train_ticket_main',
  EUROPE_TRAIN_TICKET_SEARCH_BRIDGE = 'europe_train_ticket_search_bridge',
  EUROPE_TRAIN_TICKET_SEARCH_RESULT = 'europe_train_ticket_search_result',
  EUROPE_TRAIN_TICKET_OPTION = 'europe_train_ticket_option',
  EUROPE_TRAIN_TICKET_DETAILS = 'europe_train_ticket_details',
  EUROPE_TRAIN_TICKET_PASSENGER_DETAILS = 'europe_train_ticket_passenger_details',
}

export const enum WeblogEventName {
  EUROPE_TRAIN_TICKET_MAIN = 'europe_train_ticket_main',
  EUROPE_TRAIN_TICKET_SEARCH_BRIDGE = 'europe_train_ticket_search_bridge',
  EUROPE_TRAIN_TICKET_SEARCH_RESULT = 'europe_train_ticket_search_result',
  EUROPE_TRAIN_TICKET_OPTION = 'europe_train_ticket_option',
  EUROPE_TRAIN_TICKET_DETAILS = 'europe_train_ticket_details',
  EUROPE_TRAIN_TICKET_PASSENGER_DETAILS = 'europe_train_ticket_passenger_details',
  TAB_CLICK = 'tab_click',
  JOURNEY_SELECT = 'journey_select',
  SEARCH = 'search',
  RECOMMENDED_PASS = 'recommended_pass',
  REGION_TAB = 'region_tab',
  FIND_MY_PASS = 'find_my_pass',
  DEPARTURE = 'departure',
  POPULAR_DEPARTURE = 'popular_departure',
  POPULAR_ROUTE = 'popular_route',
  SELECT_DEPARTURE = 'select_departure',
  ARRIVAL = 'arrival',
  POPULAR_ARRIVAL = 'popular_arrival',
  SELECT_ARRIVAL = 'select_arrival',
  SELECT_DATE = 'select_date',
  CALENDAR_APPLY = 'calendar_apply',
  PAX = 'pax',
  APPLY_PAX = 'apply_pax',
  OFFER = 'offer',
  FILTER = 'filter',
  SORT = 'sort',
  TRANSFERS = 'transfers',
  APPLY_FILTER = 'apply_filter',
  APPLY_SORT = 'apply_sort',
  ROUTE_DETAILS = 'route_details',
  ROUTE_DETAILS_SELECT_ROUTE = 'route_details_select_route',
  EUROPE_TRAIN_TICKET_OPTION_COMPLETE = 'europe_train_ticket_option_complete',
  EXPAND_MAP = 'expand_map',
  CHANGE_OPTION = 'change_option',
  ENTER_PASSENGER_DETAILS = 'enter_passenger_details',
  RESERVE = 'reserve',
}
